var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlyph052Locator = function SvgGlyph052Locator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 337 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.21 128.89A139.59 139.59 0 1 0 69.8 326.29L168.5 425l98.71-98.71a139.58 139.58 0 0 0 0-197.4m-10.61 186.8c-.53.53-62.72 62.71-88.1 88.1-25.38-25.39-87.57-87.57-88.1-88.1a124.59 124.59 0 1 1 176.2 0m-44.35-88.1a43.75 43.75 0 1 1-43.75-43.74 43.75 43.75 0 0 1 43.75 43.74"
  })));
};
export default SvgGlyph052Locator;